import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";
import { CartContext } from "./CartContext";
import productData from "../Datas/productData";
import "../css/checkout.css";

const SHIPPING = 9.99;
const UNAVAILABLE_COUNTRIES = ["AF", "BY", "CU", "IR", "KP", "MM", "RU", "SD", "SS", "SY", "VE", "YE"];

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [form, setForm] = useState({
    email: "",
    country: "",
    firstName: "",
    lastName: "",
    company: "",
    address: "",
    address2: "",
    city: "",
    postalCode: "",
  });
  const [errors, setErrors] = useState({});

  const getProductById = (id) => productData.find((product) => product.id === id);
  const items = cartItems
    .map((item) => ({ ...item, product: getProductById(item.id) }))
    .filter((item) => item.product);
  const subtotal = items.reduce(
    (total, item) => total + Number(item.product.price) * item.quantity,
    0
  );
  const total = subtotal + (items.length ? SHIPPING : 0);

  const update = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
    setErrors((current) => ({ ...current, [field]: "" }));
  };

  const validate = () => {
    const next = {};
    if (!/^\S+@\S+\.\S+$/.test(form.email)) next.email = "Enter a valid email address";
    if (!form.country) next.country = "Select a delivery country";
    if (!form.firstName.trim()) next.firstName = "Enter a first name";
    if (!form.lastName.trim()) next.lastName = "Enter a last name";
    if (!form.address.trim()) next.address = "Enter a street address";
    if (!form.city.trim()) next.city = "Enter a city";
    if (!form.postalCode.trim()) next.postalCode = "Enter a postal code";
    if (!items.length) next.cart = "Your cart is empty";
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    if (!validate()) return;

    const orderNo = `${Date.now()}${Math.floor(100000 + Math.random() * 900000)}`;
    const origin = window.location.origin;
    const params = new URLSearchParams({
      orderNo,
      amount: total.toFixed(2),
      currency: "USD",
      email: form.email.trim(),
      success_url: `${origin}/payment?state=success`,
      cancel_url: `${origin}/payment?state=cancel`,
      title: items[0].product.name,
    });

    window.location.assign(`${origin}/create_payment.php?${params.toString()}`);
  };

  return (
    <div className="main-containerCheck">
      <div className="check-custom-checkout-page">
        <div className="left">
          <div className="check-order-info">
            <form onSubmit={handlePlaceOrder} noValidate>
              <div className="form-group">
                <label htmlFor="email">Contact</label>
                <input
                  type="email"
                  id="email"
                  value={form.email}
                  placeholder="Email address"
                  onChange={(event) => update("email", event.target.value)}
                  autoComplete="email"
                />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>

              <div className="form-group">
                <label>Delivery</label>
                <ReactFlagsSelect
                  selected={form.country}
                  onSelect={(code) => update("country", code)}
                  countries={UNAVAILABLE_COUNTRIES}
                  blacklistCountries
                  searchable
                  searchPlaceholder="Search countries"
                  placeholder="Select country"
                  className="check-select"
                />
                {errors.country && <p className="error">{errors.country}</p>}
                <p className="delivery-note">Unavailable destinations are removed in line with applicable sanctions and service restrictions.</p>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input type="text" value={form.firstName} placeholder="First name *" onChange={(event) => update("firstName", event.target.value)} autoComplete="given-name" />
                  {errors.firstName && <p className="error">{errors.firstName}</p>}
                </div>
                <div className="form-group">
                  <input type="text" value={form.lastName} placeholder="Last name *" onChange={(event) => update("lastName", event.target.value)} autoComplete="family-name" />
                  {errors.lastName && <p className="error">{errors.lastName}</p>}
                </div>
              </div>

              <div className="form-group">
                <input type="text" value={form.company} onChange={(event) => update("company", event.target.value)} placeholder="Company name (optional)" autoComplete="organization" />
              </div>

              <div className="form-group">
                <input type="text" value={form.address} onChange={(event) => update("address", event.target.value)} placeholder="Address *" autoComplete="address-line1" />
                {errors.address && <p className="error">{errors.address}</p>}
              </div>

              <div className="form-group">
                <input type="text" value={form.address2} onChange={(event) => update("address2", event.target.value)} placeholder="Apartment, suite, etc. (optional)" autoComplete="address-line2" />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input type="text" value={form.city} placeholder="City *" onChange={(event) => update("city", event.target.value)} autoComplete="address-level2" />
                  {errors.city && <p className="error">{errors.city}</p>}
                </div>
                <div className="form-group">
                  <input type="text" value={form.postalCode} placeholder="Postal code *" onChange={(event) => update("postalCode", event.target.value)} autoComplete="postal-code" />
                  {errors.postalCode && <p className="error">{errors.postalCode}</p>}
                </div>
              </div>

              <div className="form-group shipping-method-box">
                <label>Shipping method</label>
                <div><span>Standard tracked shipping</span><strong>$9.99 USD</strong></div>
              </div>

              <div className="form-group">
                <label>Payment</label>
                <div className="payment-redirect-note">
                  After selecting Pay Now, you will be redirected to the secure payment page. No card details are collected on this form.
                </div>
              </div>

              {errors.cart && <p className="error checkout-cart-error">{errors.cart}</p>}
              <button className="check-checkout-button" type="submit">Pay Now</button>
            </form>

            <p><Link to="/returns" style={{ textDecoration: "underline" }}>Shipping &amp; Returns Info</Link></p>
          </div>
        </div>

        <div className="right">
          <div className="check-order-summary">
            <div className="check-order-details">
              {items.map((item) => (
                <div key={`${item.id}-${item.size}-${item.color}`} className="check-cart-item">
                  <img src={item.product.detailImage} alt={item.product.name} />
                  <div className="pro--qty"><div className="qty-inner">{item.quantity}</div></div>
                  <div className="check-item-details">
                    <h3>{item.product.name}{item.size && <><br />Size: {item.size}</>}{item.color && <><br />Color: {item.color}</>}</h3>
                  </div>
                  <p className="cal-single">${(Number(item.product.price) * item.quantity).toFixed(2)}</p>
                </div>
              ))}

              <div className="check-summary-details">
                <div className="checkout-summary-row"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
                <div className="checkout-summary-row"><span>Shipping</span><span>${items.length ? SHIPPING.toFixed(2) : "0.00"}</span></div>
                <div className="checkout-summary-row total"><strong>Total</strong><strong>${total.toFixed(2)} USD</strong></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckOut;
